@use "variables" as *;

.cancelButton {
  color: indianred;
}

.textField {
  height: 60px;
}

.loadingDiv {
  width: 50px;
  padding-left: $spacing-m;
}

.dropzone {
  height: 130px !important;
  width: 130px !important;
  align-self: center;
  flex-shrink: 0;
}

.profileCard {
  margin-bottom: $spacing-s;
  border-radius: 12px !important;
}

.toggleButton {
  width: 100%;
}
